module.exports = __webpack_public_path__ + "img/base_activites_bateau.fc8a02a4.svg";